import React, { useState, forwardRef } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { Dialog } from '@mui/material'

import { userRightTypes } from '../../../../constants'
import { checkErrorResponse, Logger, LoggerTypes } from '../../../../utils'
import { updateProject } from '../../../../actions'
import { AccessControl, AccessControlNoRights } from '../../../../components'
import { ProjectForm } from '../ProjectCreate'
import './style.scss'

export const ProjectDialogUpdate = forwardRef(({ project, openDialog, setOpenDialog }, ref) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [errors, setErrors] = useState(null)

  const onClickCancel = (e) => {
    e.preventDefault()

    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectDialogUpdate.onClickCancel()', { e })

    setOpenDialog(!openDialog)
  }

  const onSubmit = (e, projectUpdated) => {
    e.preventDefault()
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectDialogUpdate.onSubmit()', { projectUpdated })

    dispatch(updateProject(projectUpdated))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'ProjectDialogUpdate.onSubmit().updateProject().then()', { res })
        setOpenDialog(!openDialog)
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'ProjectDialogUpdate.onSubmit().updateProject().catch()', { res })

        checkErrorResponse(res, enqueueSnackbar, t)

        if (res?.response?.data?.fields) {
          setErrors(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'ProjectDialogUpdate.render()', { openDialog, project, errors })

  return (
    <Dialog
      ref={ref}
      fullwidth={false}
      maxWidth={'lg'} // xs | sm | md | lg | xl
      open={openDialog}
      onClose={onClickCancel}
      className="ProjectDialogUpdate"
    >
      <AccessControl userPermissions={[userRightTypes.PROJECT_EDIT]} renderNoAccess={() => <AccessControlNoRights />}>
        <ProjectForm onCancel={onClickCancel} onSubmit={onSubmit} project={project} errors={errors} />
      </AccessControl>
    </Dialog>
  )
})

ProjectDialogUpdate.displayName = 'ProjectDialogUpdate'

ProjectDialogUpdate.propTypes = {
  project: PropTypes.object.isRequired,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired
}

ProjectDialogUpdate.defaultProps = {
  project: {},
  openDialog: false,
  setOpenDialog: () => {}
}
